<template>
    <div class="box" v-if="client">
      <div class="columns has-text-text notification">
        <div class="column is-5">
          <div class="columns">
            <div class="column is-5">
              <img src="@/assets/default-placeholder.png" style="width: 5vw; height: 10vh;"/>
            </div>
            <div class="column">
              <p><strong>{{client.nomCommercial}} - {{client.nomCourt}}</strong></p>
              <p>N° du compte : <strong>{{client.numeroCompte}}</strong></p>
              <p>Siret : <strong>{{client.siret}}</strong></p>
              <p>Siren : <strong>{{client.siren}}</strong></p>
              <br>
              <p>Secteur : <strong>{{client.secteurActivite}}</strong></p>
            </div>
          </div>
          <p><strong>Commentaire :</strong></p>
          <p>{{client.commentaire}}</p>
        </div>
        <div class="column">
          <p><strong>Infos contact :</strong></p>
          <p>Téléphone : <strong>{{client.telephone}}</strong></p>
          <p>FAX : <strong>{{client.fax}}</strong></p>
          <p>Email : <strong>{{client.email}}</strong></p>
          <p>Site web : <a>{{client.siteWeb}}</a></p>
          <br>
          <p><strong>Informations réglements :</strong></p>
          <p>Code APE : <strong>{{client.codeApe}}</strong></p>
          <p>Mode réglement : <strong>
            {{client.modeReglement ? client.modeReglement.libelle : ''}}</strong></p>
          <p>Délai de paiement : <strong>
            {{client.delaiPaiement ? client.delaiPaiement.libelle : ''}}</strong></p>
          <p>N° TVA : <strong>{{client.numeroTva}}</strong></p>
          <p v-if="isAffixe2">
            Application TVA : <strong>{{getApplicationTva(client.applicationTva)}}</strong>
          </p>
        </div>
        <div class="column">
          <p><strong>Adresse :</strong></p>
          <p>{{client.adrIntitule1}}</p>
          <p>{{client.adrIntitule2}}</p>
          <p>{{client.adrIntitule3}}</p>
          <p>{{client.adrLibelle1}}</p>
          <p>{{client.adrLibelle2}}</p>
          <p>{{client.adrLibelle3}}</p>
          <p>{{client.adrCp}}
            <span v-if="client.adrCp && client.adrVille"> - </span>
            {{client.adrVille}}
          </p>
          <br>
          <p><strong>Facturation :</strong></p>
          <p>{{client.adrFIntitule1}}</p>
          <p>{{client.adrFIntitule2}}</p>
          <p>{{client.adrFIntitule3}}</p>
          <p>{{client.adrFLibelle1}}</p>
          <p>{{client.adrFLibelle2}}</p>
          <p>{{client.adrFLibelle3}}</p>
          <p>{{client.adrFCp}}
            <span v-if="client.adrFCp && client.adrFVille"> - </span>
            {{client.adrFVille}}
          </p>
        </div>
      </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { LISTE_APPLICATION_TVA } from '@/configuration/applicationTvaConf';

const Client = createNamespacedHelpers('client');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'fiche',
  computed: {
    ...Client.mapGetters([
      'client',
    ]),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
  },
  methods: {
    getApplicationTva(code) {
      return LISTE_APPLICATION_TVA.find(item => item.code === code).libelle;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/information/fiche.vue